const ButtonVariantContained = "contained";
const ButtonVariantOutlined  = "outlined";
const ButtonVariantText      = "text";

export {
  ButtonVariantContained, ButtonVariantOutlined, ButtonVariantText
}